import React, { useState } from "react"
import { ProviderFinderParam, useStringSearchParam } from "#/pages/provider-finder/utils/providerFinderSearchUrl"
import { KeywordAutocomplete } from "../keyword-search/KeywordAutocomplete"
import { ForwardIcon, SearchIcon } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import { useProviderTypeSearched } from "#/pages/provider-finder/components/results/useProviderTypeSearched"

export function SidebarKeywordSearch(): JSX.Element {
  const [providerNameSearchValue, setProviderNameSearchValue] = useState(null)
  const [keyword, setKeyword] = useStringSearchParam(ProviderFinderParam.Keyword)
  const [providerIdParam, setProviderIdParam] = useStringSearchParam(ProviderFinderParam.ProviderId)
  // Seed from the URL so a resubmit without a typeahead re-pick preserves
  // the exact-id lookup. Empty init would silently clear the id on submit
  // and fall the results back to a fuzzy keyword search.
  const [providerIdSearchValue, setProviderIdSearchValue] = useState(providerIdParam ?? "")
  const [, setSearch] = useStringSearchParam(ProviderFinderParam.Search)
  const [, setRadiusInKm] = useStringSearchParam(ProviderFinderParam.RadiusInKm)
  const intl = useIntl()

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setKeyword(providerNameSearchValue)
    // Always overwrite providerId — including clearing it when the member's
    // current input isn't a typeahead pick. Otherwise a stale id from an
    // earlier search would outlive the new query and byIds would ignore
    // the sidebar's keyword.
    setProviderIdParam(providerIdSearchValue)
    setSearch("")
    setRadiusInKm("")
  }

  const { providerTypeId } = useProviderTypeSearched()

  return (
    <>
      <form onSubmit={handleSubmit}>
        <KeywordAutocomplete
          keyword={keyword}
          popupIcon={
            <ForwardIcon
              fontSize="medium"
              sx={(theme) => ({
                marginInlineStart: theme.spacing(theme.tokens.spacing.xxs),
                marginInlineEnd: theme.spacing(theme.tokens.spacing.xxs)
              })}
              onClick={handleSubmit}
            />
          }
          placeholder={intl.formatMessage({ defaultMessage: "Search" })}
          startAdornment={
            <SearchIcon
              fontSize="medium"
              sx={(theme) => ({
                color: theme.palette.text.disabled,
                marginInlineStart: theme.spacing(theme.tokens.spacing.xxs),
                marginInlineEnd: theme.spacing(theme.tokens.spacing.xxs)
              })}
            />
          }
          setProviderNameValue={setProviderNameSearchValue}
          setProviderIdValue={setProviderIdSearchValue}
          sx={{
            ".MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent"
            },
            "& .MuiAutocomplete-popupIndicator": { transform: "none" }
          }}
          providerType={providerTypeId}
        />
      </form>
    </>
  )
}
